import  { ReactNode } from 'react';

interface TitleWithContentProps {
    title: string;
    /** Heading level: sections use 2 (the default). The page's main title is the TitleBar (h1). */
    level?: 1 | 2 | 3;
    children?: ReactNode; // Adjusted to accept ReactNode
}

const TitleWithContent = ({ title, level = 2, children }: TitleWithContentProps) => {
    const Heading = `h${level}` as 'h1' | 'h2' | 'h3';

    return (
        <>
            <div style={{
                 paddingLeft: "clamp(.2rem, 10vw, 15rem)",
                 paddingRight: "clamp(.2rem, 10vw, 15rem)",
                 paddingTop: "clamp(.2rem, 2vw, 4rem)",
                 paddingBottom: "clamp(.2rem, 2vw, 4rem)",      
            }}
            className="group tracking-tight">
                <Heading className="h1 font-bold ">{title}</Heading>
                <div style={{
                    marginBottom: "clamp(0.2rem, 2vw, 1rem)",
                }} className="" />
                {children} 
            </div>
        </>
    );
};

export default TitleWithContent;
